import { z } from 'zod';

import type { SilenceTrigger } from '../../../utilities';

export const silenceTriggerSchema = z.object({
  sec: z.number().min(1, 'Must be at least 1 second.'),
  msg: z.string().min(1, 'Message cannot be empty.'),
});

const silenceTriggersArraySchema = z.array(silenceTriggerSchema);

export const getFieldErrors = (
  item: SilenceTrigger
): Partial<Record<keyof SilenceTrigger, string>> => {
  const result = silenceTriggerSchema.safeParse(item);
  if (result.success) return {};

  return Object.fromEntries(
    result.error.errors.map(err => [err.path[0], err.message])
  ) as Partial<Record<keyof SilenceTrigger, string>>;
};

export const validateSilenceTriggers = (
  value?: SilenceTrigger[]
): string | false => {
  if (!value || value.length === 0) return false;

  const result = silenceTriggersArraySchema.safeParse(value);
  if (result.success) return false;

  return result.error.errors
    .map(err => {
      const [index, field] = err.path;
      return `Trigger #${Number(index) + 1} (${field}): ${err.message}`;
    })
    .join(', ');
};
